import { useCallback, useState } from 'react';
import { getInstagramAudio, InstagramAudio } from '@round/api';

export default function useInstagramAudio(audioId?: number | undefined) {
    const [audio, setAudio] = useState<InstagramAudio | null>(null);
    const [isInitialized, setIsInitialized] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const init = useCallback(
        async (requestInit?: RequestInit) => {
            if (typeof audioId !== 'number') {
                return;
            }

            try {
                setIsLoading(true);
                setError(null);
                const response = await getInstagramAudio(audioId, requestInit);
                if (response.status !== 200) {
                    setError(response.data.detail);
                    setIsInitialized(true);
                    return;
                }

                setAudio(response.data);
                setIsInitialized(true);
            } catch (e) {
                if (e instanceof Error && e.name === 'AbortError') {
                    return;
                }

                setError('Could not fetch instagram audio');
                setIsInitialized(true);
            } finally {
                setIsLoading(false);
            }
        },
        [audioId]
    );

    return {
        audio,
        isLoading,
        isInitialized,
        error,
        init,
    };
}
